import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SelectableObjectModel } from '../../model/selectable-object.model';

/**
 * * Componente de Multi Seleção.
 */
@Component({
  selector: 'ui-generic-multi-select',
  templateUrl: './generic-multi-select.component.html',
  styleUrls: ['./generic-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericMultiSelectComponent {

  /**
   * * Lista de Elementos disponíveis.
   */
  private _list: SelectableObjectModel[] = [];

  /**
   * * Título
   */
  @Input()
  public title!: string;


  @Input()
  public placeholderText: string = 'Selecione uma Opção';

  /**
   * * Exibir Opções.
   */
  @Input()
  public showOptions: boolean = false;

  /**
   * * Exibir Opções Selecionadas.
   */
  @Input()
  public showSelectedList: boolean = true;

  /**
   * * Largura igual ao conteúdo.
   */
  @Input()
  public widthFitContent: boolean = false;

  /**
   * * Estilo de cores primário (azul).
   */
  @Input()
  public primaryStyle: boolean = false;

  /**
   * * Ícone para o input.
   */
  @Input()
  public icon!: string;
  /**
   * * Lista de Elementos Selecionados.
   */
  selectedlist: SelectableObjectModel[] = [];


  // TODO: Incluir descrição para os eventos.

  @Output() textValuelista = new EventEmitter<any>();
  @Output() oc = new EventEmitter<any>();

  onValue(value: SelectableObjectModel) {
    value.selected = false;

    // Deseleciona da lista
    const filter = this.list.filter(item => item.id === value.id);
    filter[0].selected = false;
    this.selectedlist = this.selectedlist.filter(item => item.id !== value.id);
    this.textValuelista.emit(this.selectedlist);
  }

  changeOptions() {
    // console.log(this.showOptions);
    this.showOptions = !this.showOptions;
    this.oc.emit(this.showOptions);
  }

  constructor() { }

  get list(): SelectableObjectModel[] {
    return this._list;
  }


  /**
   * * Lista de Elementos disponíveis.
   */
  @Input()
  public set list(list: SelectableObjectModel[]) {
    this._list = list;
    this.selectedlist = list.filter(item => item.selected);
  }

  onSelect(event: any, item: SelectableObjectModel) {
    this.oc.emit(this.showOptions);
    if (event.target.id === 'conectado-select') {
      if (this.selectedlist.includes(item)) {
        item.selected = false;
        this.selectedlist = this.selectedlist.filter(selected => selected.id !== item.id);
        this.textValuelista.emit(this.selectedlist);
      } else {
        item.selected = true;
        this.selectedlist.push(item);
        this.textValuelista.emit(this.selectedlist);
      }
    }
  }
}
